import {Component, inject} from '@angular/core';
import {forkJoin, Observable} from 'rxjs';
import {toSignal} from '@angular/core/rxjs-interop';
import {DirectusService, TextTemplate} from '@frontend/directus';
import {TranslateDirectusTemplatePipe} from '@frontend/transloco';
import {SafeHtmlComponent} from '../../../shared/components/safe-html-output/safe-html-output.component';

const TEMPLATE_KEYS = {
  intro: 'hr_tool_overview_intro',
  noticeContent: 'hr_tool_overview_notice_content',
} as const;

interface HrToolInfoBoxContent {
  intro: TextTemplate | null;
  noticeContent: TextTemplate | null;
}

@Component({
  selector: 'app-hr-tool-info-box',
  imports: [SafeHtmlComponent, TranslateDirectusTemplatePipe],
  templateUrl: './hr-tool-info-box.component.html',
})
export class HrToolInfoBoxComponent {
  private readonly directusService = inject(DirectusService);

  protected readonly content = toSignal(
    forkJoin({
      intro: this.directusService.loadTextTemplate(TEMPLATE_KEYS.intro),
      noticeContent: this.directusService.loadTextTemplate(TEMPLATE_KEYS.noticeContent),
    }) as Observable<HrToolInfoBoxContent>,
    {
      initialValue: {
        intro: null,
        noticeContent: null,
      } as HrToolInfoBoxContent,
    },
  );
}
